import { FileSystemRecord } from "./FileSystemRecord";

/**
 * Compare the `addtionalMetadata` field of two records.
 * Works on plain objects as well as real FileSystemRecord instances.
 */
export function additionalDataIsSame(
  a: Pick<FileSystemRecord, "addtionalMetadata">,
  b: Pick<FileSystemRecord, "addtionalMetadata">
): boolean {
  if (a.addtionalMetadata === b.addtionalMetadata) return true;

  const isDict = (v: unknown): v is Record<string, any> =>
    typeof v === "object" && v !== null && !Array.isArray(v);

  if (!isDict(a.addtionalMetadata) || !isDict(b.addtionalMetadata)) return false;

  const aKeys = Object.keys(a.addtionalMetadata);
  const bKeys = Object.keys(b.addtionalMetadata);
  if (aKeys.length !== bKeys.length) return false;

  return aKeys.every(
    (k) => a.addtionalMetadata[k] === b.addtionalMetadata[k]
  );
}
